import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import RetinaImage from 'react-retina-image';
import logoImg from '../../resources/img/logo-kiss.png';
import logoImg2x from '../../resources/img/logo2x.png';
import smallLogoImg from '../../resources/img/logoSmall2.png';
import logoVerySmall from '../../resources/img/logoVerySmall.png';

class Logo extends Component {

    componentWillMount() {
        window.addEventListener("resize", this.showLogo);
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.showLogo);
    }

    showLogo() {
        if(window.innerWidth > 400) {
            return (
                <Link to={'/'}>
                    <RetinaImage src={[logoImg, logoImg2x]} alt={"Cinemap"} checkIfRetinaImgExists={true}/>
                </Link>
            )
        } else if (window.innerWidth < 340) {
            return (
                <Link to={'/'}>
                    <img src={logoVerySmall} alt={"Cinemap"} className="logoImage"/>
                </Link>
            )
        } else {
            return (
                <Link to={'/'}>
                    <img src={smallLogoImg} alt={"Cinemap"} className="logoImage"/>
                </Link>
            )
        }
    };

    render() {
        return (
                <div className="logo">
                    {/*<Link to={'/'}><img src={logoImg} alt={"Cinemap"} className="logoImage"/></Link>*/}
                    { this.showLogo() }
                </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(Logo);



// WEBPACK FOOTER //
// ./src/FO/components/logo/logo.component.js